import { ServiceAuditorDisplayStatus } from '@commenda/api/agent-platform/service-auditor/types';

export enum ServiceAuditWaitStepState {
  WAITING = 'WAITING',
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED',
}

export class ServiceAuditWaitStepHelper {
  static readonly WAIT_STEP_STATUS_LABELS: Readonly<
    Record<ServiceAuditWaitStepState, string>
  > = {
    [ServiceAuditWaitStepState.WAITING]: 'Waiting for the audit',
    [ServiceAuditWaitStepState.FAILED]: 'Audit failed',
    [ServiceAuditWaitStepState.COMPLETED]: 'Audit completed',
  };

  static readonly WAIT_STEP_STATUS_CLASS_NAMES: Readonly<
    Record<ServiceAuditWaitStepState, string>
  > = {
    [ServiceAuditWaitStepState.WAITING]: 'text-text-tertiary',
    [ServiceAuditWaitStepState.FAILED]: 'text-text-error',
    [ServiceAuditWaitStepState.COMPLETED]: 'text-text-success',
  };

  static getWaitStepState(
    auditStatus: ServiceAuditorDisplayStatus | null
  ): ServiceAuditWaitStepState {
    if (auditStatus === ServiceAuditorDisplayStatus.FAILED) {
      return ServiceAuditWaitStepState.FAILED;
    }
    if (auditStatus === ServiceAuditorDisplayStatus.COMPLETED) {
      return ServiceAuditWaitStepState.COMPLETED;
    }
    return ServiceAuditWaitStepState.WAITING;
  }
}
